import { useCallback } from 'react';
import { useSWRConfig } from 'swr';

const CALLER_REVIEW_QUERY_PATHS = new Set([
    '/organizations/{organization_id}/voice-calls',
    '/organizations/{organization_id}/voice-calls/{voice_call_id}',
    '/organizations/{organization_id}/activity-events',
    '/organizations/{organization_id}/activity-events/{event_id}',
    '/organizations/{organization_id}/activity-events/counts',
    '/organizations/{organization_id}/activity-events/kind-counts',
    '/organizations/{organization_id}/clients',
    '/organizations/{organization_id}/clients/{client_id}',
]);

export function isCallerReviewQueryKey(
    key: unknown,
    organizationId: string,
): boolean {
    if (!Array.isArray(key)) {
        return false;
    }
    if (
        key[0] === 'infinite-voice-calls' ||
        key[0] === 'infinite-activity-events'
    ) {
        return key[1] === organizationId;
    }
    if (
        key[0] !== 'get' ||
        typeof key[1] !== 'string' ||
        !CALLER_REVIEW_QUERY_PATHS.has(key[1])
    ) {
        return false;
    }
    const pathParams = key[2];
    return (
        typeof pathParams === 'object' &&
        pathParams !== null &&
        'organization_id' in pathParams &&
        pathParams.organization_id === organizationId
    );
}

export function useInvalidateCallerReviewQueries(
    organizationId: string,
): () => Promise<void> {
    const { mutate } = useSWRConfig();
    return useCallback(async () => {
        await mutate((key) => isCallerReviewQueryKey(key, organizationId));
    }, [mutate, organizationId]);
}
